// ── Chip и Badge — плашки ────────────────────────────────────────────────────
// Chip — нажимаемая плашка-переключатель: сортировка («Новые / А–Я»), фильтры,
// разделители при импорте. Высота 32 px — по ней попадают пальцем.
// Badge — просто подпись-плашка (не нажимается): «Pro», «3 новых», статус.
// Обе не растягиваются шире родителя: длинный текст — «…» и подсказка.

import Icon from '../Icon';
import { SANS } from '../themes';
import { usePalette } from './theme';
import { labelOn, shade } from './color';

export function Chip({ children, selected = false, icon, count, onClick, size = 'md', style, C: Cp, title, ...rest }) {
  const C = usePalette(Cp);
  const label = typeof children === 'string' ? children : undefined;
  // Объёмная тема («Аркада»): чип — объёмная кнопка; выбранный залит синим, как фишка,
  // невыбранный — тёмный с кристальной гранью (index.css).
  const lift = !!C.lift;
  const lb = lift && selected ? labelOn(C, C.blue) : null;
  // тема может задать свой выбранный чип («Колода» — светлый с тёмной надписью, как на макете)
  const bg = selected ? (lift ? C.blue : C.chipOnBg || C.bluePale) : lift ? C.surface : 'transparent';
  const fg = lb ? lb.fg : selected ? C.chipOnFg || C.blueDark : C.mid;
  return (
    <button type="button" onClick={onClick} aria-pressed={selected} title={title || label}
      data-lift={lift ? '' : undefined} data-crystal={lift && !selected ? '' : undefined} data-outline={lb?.outline ? '' : undefined}
      className={[selected ? '' : 'ac-ibtn', size === 'sm' ? 'ac-hit' : ''].filter(Boolean).join(' ') || undefined}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, minHeight: size === 'sm' ? 28 : 32, maxWidth: '100%', minWidth: 0,
        padding: size === 'sm' ? '2px 10px' : '4px 12px', borderRadius: 8, boxSizing: 'border-box', flexShrink: 0,
        border: `1px solid ${selected ? 'transparent' : C.border}`, background: bg, '--ac-edge': lift ? shade(bg) : undefined,
        color: fg, fontFamily: SANS, fontSize: 12.5, fontWeight: selected ? 600 : 500, cursor: 'pointer', ...style }}
      {...rest}>
      {icon && <span style={{ display: 'inline-flex', flexShrink: 0 }}><Icon n={icon} s={14} /></span>}
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{children}</span>
      {count != null && <span style={{ flexShrink: 0, fontWeight: 700, color: lb ? lb.fg : selected && C.chipOnFg ? C.chipOnFg : C.blueDark, fontVariantNumeric: 'tabular-nums' }}>{count}</span>}
    </button>
  );
}

const TONES = (C) => ({
  neutral: [C.surface, C.mid],
  blue: [C.bluePale, C.blueDark],
  green: [C.greenPale, C.green],
  warm: [C.warmPale, C.warmDark],
  danger: [C.surface, C.danger],
});

export function Badge({ children, tone = 'neutral', icon, style, C: Cp, title, ...rest }) {
  const C = usePalette(Cp);
  const [bg, fg] = TONES(C)[tone] || TONES(C).neutral;
  return (
    <span title={title || (typeof children === 'string' ? children : undefined)}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, maxWidth: '100%', minWidth: 0, height: 22, padding: '0 8px',
        borderRadius: 999, background: bg, color: fg, fontFamily: SANS, fontSize: 12, fontWeight: 600, lineHeight: '22px',
        boxSizing: 'border-box', flexShrink: 0, verticalAlign: 'middle', ...style }}
      {...rest}>
      {icon && <Icon n={icon} s={12} />}
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{children}</span>
    </span>
  );
}
